import React, { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { IconSpinner } from '../../components';

type LoadingProps = {
  textColor?: string;
  hoverColor?: string;
};

const useStyles = makeStyles({
  parent: {
    display: 'flex',
    justifyContent: 'center',
    // no styles here but defines the hover selector
    '&:hover $spinner': {
      stroke: (props: LoadingProps) => props.hoverColor || props.textColor || '#000000',
    },
  },
  spinner: {
    stroke: (props: LoadingProps) => props.textColor || '#000000',
  },
});

export const Loading: FC<LoadingProps> = ({ textColor, hoverColor }) => {
  const classes = useStyles({ textColor, hoverColor });

  return (
    <Box className={classes.parent}>
      <IconSpinner className={classes.spinner} />
    </Box>
  );
};
